import type { ReactNode } from "react";
import { Label } from "@radix-ui/react-label";
import ImageContainer from "../../../components/general/ImageContainers/ImageContainer";
import { notUndefined } from "../../../utils/type-guards/general";

const ListItemList = ({
	label,
	children,
}: {
	label?: string;
	children: ReactNode[];
}) => {
	return (
		<div className="@container flex w-full flex-col gap-2">
			{label && <Label>{label}</Label>}
			<ul className="grid grid-cols-1 gap-2 @[470px]:grid-cols-2">
				{children.map((item, index) => (
					<li key={index}>{item}</li>
				))}
			</ul>
		</div>
	);
};

const ListItem = ({
	label,
	description,
	children,
}: {
	label?: string;
	description?: string;
	children?: React.ReactNode;
}) => {
	return (
		<div className="flex w-full items-center gap-2">
			<div className="h-[72px] max-w-[72px]">{children}</div>
			<div className="flex flex-col gap-1">
				<h5 className="bb-text-body text-gray-4 !leading-4">{label}</h5>
				<p className="bb-text-tiny text-gray-2 !leading-4">{description}</p>
			</div>
		</div>
	);
};

const CarryPositionsModule = ({
	positions,
}: Queries.CarryPositionsFragment) => {
	const positionsProps = positions
		?.map((position) => {
			if (!position || !position.image?.filename) return;

			return {
				uid: position._uid,
				image: {
					src: position.image.filename,
					alt: position.image.alt ?? undefined,
				},
				label: position.label ?? undefined,
				description: position.description ?? undefined,
			};
		})
		.filter(notUndefined);

	return positionsProps ? (
		<ListItemList>
			{positionsProps.map((position) => {
				return (
					<ListItem
						key={position.uid}
						label={position.label}
						description={position.description}
					>
						<ImageContainer
							imgSrc={position.image.src}
							alt={position.image.alt}
							ratio="square"
						/>
					</ListItem>
				);
			})}
		</ListItemList>
	) : null;
};

export default CarryPositionsModule;
